const convertDaysToIsoDuration = (days: number | undefined): string | undefined => {
    if (days === undefined) {
        return;
    }
    let isNegative = false;
    if (days < 0) {
        isNegative = true;
        days = -days;
    }
    const isoDuration = `${isNegative ? '-' : ''}P${days}D`;
    return isoDuration;
};

export default convertDaysToIsoDuration;
